module.exports = __webpack_public_path__ + "img/BG_Desktop_Pink.dc175107.png";